import React, { useEffect, useRef, useState } from "react";
import { TextField, Button, MenuItem, Card, Typography, IconButton } from "@mui/material";
import { categoryApi } from "store/api";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CategoryClip from "./CategoryClip";
import Tooltip from "@mui/material/Tooltip";
import { useLocation } from "react-router";
import { productDetailApi } from "store/api";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { productUpdateDimentionsDetailsApi } from "store/api";
import { productUpdateBasicDetailsApi } from "store/api";
import TooltipShow from "components/Utilities/TooltipShow";
import DeleteIcon from "@mui/icons-material/Delete";
import UpgradeRoundedIcon from "@mui/icons-material/UpgradeRounded";
import { updateProductDescriptionApi } from "store/api";
import { updateProductInventryApi } from "store/api";
import { updateProductCharacteristicApi } from "store/api";
import { updateProductColorApi } from "store/api";
import Success from "components/Success";
import { updateProductWarrantyApi } from "store/api";
import { updateProductVideoApi } from "store/api";

const ProductEditForm = () => {
  const location = useLocation();
  const productParams = location.state;
  const [msg, setMsg] = useState("");
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [categories, setCategories] = useState([]);
  const [checkCallAPI, setCheckCallAPI] = useState(false);

  const [seeDescription, setSeeDescription] = useState(false);
  const [indexDimention, setIndexDimention] = useState("");
  const [addDescriptionShow, setAddDescriptionShow] = useState(false);

  const [seeCharacteristic, setSeeCharacteristic] = useState(false);
  const [indexCharacteristic, setIndexCharacteristic] = useState("");
  const [addCharacteristicShow, setAddCharacteristicShow] = useState(false);

  const [seeWarranty, setSeeWarranty] = useState(false);
  const [indexWarranty, setIndexWarranty] = useState("");
  const [addWarrantyShow, setAddWarrantyShow] = useState(false);

  const [seeColor, setSeeColor] = useState(false);
  const [indexColor, setIndexColor] = useState("");
  const [addColorShow, setAddColorShow] = useState(false);

  const [seeVideo, setSeeVideo] = useState(false);
  const [indexVideo, setIndexVideo] = useState("");
  const [addVideoShow, setAddVideoShow] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryClone, setSelectedCategoryClone] = useState([]);
  const [basicDetail, setBasicDetail] = useState({
    nameEn: "",
    nameUz: "",
    slug: "",
    productCode: "",
    price: "",
    discountPrice: "",
    rating: "",
  });
  const [dimensions, setDimentions] = useState({
    weight: "",
    length: "",
    width: "",
    height: "",
  });
  const [productColors, setProductColors] = useState([{ colorCode: "#000000", inventory: "" }]);
  const [productDescription, setProductDescription] = useState([
    { descriptionEn: "", descriptionUz: "", descriptionOrder: 1 },
  ]);
  const [productCharacteristic, setProductCharacteristic] = useState([
    { keyEn: "", keyUz: "", valueEn: "", valueUz: "" },
  ]);
  const [productWarranty, setProductWarranty] = useState([
    { descriptionEn: "", descriptionUz: "", price: "" },
  ]);
  const [productVideo, setProductVideo] = useState([{ video: "", videoThumbnail: "" }]);

  const getAllCategory = async () => {
    const response = await categoryApi();
    if (response?.success) {
      setCategories(response?.data);
    }
  };

  const handleChangeBasicDetail = e => {
    const { name, value } = e.target;
    setBasicDetail({ ...basicDetail, [name]: value });
  };
  const handleChangeDimentions = e => {
    const { name, value } = e.target;
    setDimentions({ ...dimensions, [name]: value });
  };
  // Handle input change
  const handleChangeCharacteristic = (index, event) => {
    if (!addCharacteristicShow) {
      setIndexCharacteristic(index);
      setSeeCharacteristic(true);
    }
    const { name, value } = event.target;
    const newProductCharacteristic = [...productCharacteristic];
    newProductCharacteristic[index][name] = value;
    setProductCharacteristic(newProductCharacteristic);
  };

  // Add new Characteristic
  const addCharacteristic = () => {
    setSeeCharacteristic(false);
    setAddCharacteristicShow(true);
    setIndexCharacteristic(productCharacteristic?.length);
    setProductCharacteristic([
      ...productCharacteristic,
      { id: Date.now(), keyEn: "", keyUz: "", valueEn: "", valueUz: "", isActive: true },
    ]);
  };

  // Remove a Characteristic
  const removeCharacteristic = id => {
    if (id != 1)
      setProductCharacteristic(
        productCharacteristic.filter(characteristic => characteristic.id !== id)
      );
  };

  const textAreaRef = useRef(null);
  // Handle input change
  const handleChangeDescription = (index, event) => {
    if (!addDescriptionShow) {
      setIndexDimention(index);
      setSeeDescription(true);
    }
    const { name, value } = event.target;
    const newProductDescription = [...productDescription];
    newProductDescription[index][name] = value;
    setProductDescription(newProductDescription);
    // const textarea = textAreaRef.current;
    // textarea.style.height = "auto"; // Reset height to auto
    // textarea.style.height = `${textarea.scrollHeight}px`; // Expand based on content
  };

  // Add new Description
  const addDescription = () => {
    setSeeDescription(false);
    setAddDescriptionShow(true);
    setIndexDimention(productDescription?.length);
    setProductDescription([
      ...productDescription,
      { id: Date.now(), descriptionEn: "", descriptionUz: "", descriptionOrder: 1, isActive: true },
    ]);
  };

  // Remove a Description
  const removeDescription = id => {
    if (id != 1)
      setProductDescription(productDescription.filter(description => description.id !== id));
  };

  // Handle input change
  const handleChangeWarranty = (index, event) => {
    if (!addWarrantyShow) {
      setIndexWarranty(index);
      setSeeWarranty(true);
    }
    const { name, value } = event.target;
    const newProductWarranty = [...productWarranty];
    newProductWarranty[index][name] = value;
    setProductWarranty(newProductWarranty);
  };

  // Add new Warranty
  const addWarranty = () => {
    setSeeWarranty(false);
    setAddWarrantyShow(true);
    setIndexWarranty(productWarranty?.length);
    setProductWarranty([
      ...productWarranty,
      { id: Date.now(), descriptionEn: "", descriptionUz: "", price: "", status: true },
    ]);
  };

  // Remove a Warranty
  const removeWarranty = id => {
    if (id != 1) setProductWarranty(productWarranty.filter(warranty => warranty.id !== id));
  };

  // Handle input change
  const handleChangeColor = (index, event) => {
    if (!addColorShow) {
      setIndexColor(index);
      setSeeColor(true);
    }
    const { name, value } = event.target;
    const newColors = [...productColors];
    // setCheckCallAPI(true);
    newColors[index][name] = value;
    setProductColors(newColors);
  };

  // Handle input change
  const handleChangeVideo = (index, event) => {
    if (!addVideoShow) {
      setIndexVideo(index);
      setSeeVideo(true);
    }
    const { name, value } = event.target;
    const newProductVideo = [...productVideo];
    newProductVideo[index][name] = value;
    setProductVideo(newProductVideo);
  };

  // Add new color
  const addColor = () => {
    setSeeColor(false);
    setAddColorShow(true);
    setIndexColor(productColors?.length);
    setProductColors([
      ...productColors,
      { id: Date.now(), color: "", hexCode: "", isActive: true },
    ]);
  };

  // Remove a color
  const removeColor = id => {
    if (id != 1) setProductColors(productColors.filter(color => color.id !== id));
  };

  // const handleSubmit = e => {
  //   e.preventDefault();
  //   const categoryData = selectedCategory.map(item => item.id);
  //   const data = {
  //     basicDetail: basicDetail,
  //     colors: productColors,
  //     dimension: dimensions,
  //     description: productDescription,
  //     characteristic: productCharacteristic,
  //     category: categoryData,
  //     warranty: productWarranty,
  //   };
  // };

  const getProductDetails = async () => {
    setProductColors([]);
    setProductCharacteristic([]);
    setSelectedCategory([]);
    setSelectedCategoryClone([]);
    setProductWarranty([]);
    setProductDescription([]);
    setProductVideo([]);
    const response = await productDetailApi(productParams);
    if (response?.success) {
      setProductColors(response?.data?.colors);
      setProductDescription(response?.data?.descriptions);
      setProductCharacteristic(response?.data?.characteristics);
      setSelectedCategory(response?.data?.categories);
      setSelectedCategoryClone(
        response?.data?.categories.map(({ categoryId, isActive }) => ({
          categoryId,
          isActive,
        }))
      );
      setProductWarranty(response?.data?.warranty);
      setProductVideo(response?.data?.videos);
      const data = response.data;
      const dimention = response.data?.productDimension;
      const basicDetailKey = [
        "nameEn",
        "nameUz",
        "slug",
        "productCode",
        "price",
        "discountPrice",
        "rating",
      ];
      const dimentionKey = ["height", "weight", "length", "width"];

      setBasicDetail(
        Object.fromEntries(Object.entries(data).filter(([key]) => basicDetailKey.includes(key)))
      );
      setDimentions(
        Object.fromEntries(Object.entries(dimention).filter(([key]) => dimentionKey.includes(key)))
      );
      // setBasicDetail({ nameEn, nameUz, slug, productCode, price, discountPrice, rating } = response?.data);
    }
  };
  const handleDimention = async e => {
    e?.preventDefault();
    const apiData = dimensions;
    apiData.productId = productParams?.productId;
    apiData.weight = parseFloat(apiData?.weight);
    const response = await productUpdateDimentionsDetailsApi(apiData);
    if (response?.success) {
      setMsg("Dimention Update Successfully");
      setSuccess(true);
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };
  const handleBasicDetail = async e => {
    e?.preventDefault();
    const categoryData = selectedCategory.map(({ categoryId, isActive }) => ({
      categoryId,
      isActive,
    }));
    const apiData = {};
    apiData.basicDetail = basicDetail;
    apiData.categories = selectedCategoryClone;
    apiData.basicDetail.productId = productParams?.productId;
    apiData.basicDetail.image = false;
    apiData.basicDetail.rating = String(basicDetail.rating);
    const response = await productUpdateBasicDetailsApi(apiData);
    if (response?.success) {
      setMsg("Product Update Successfully");
      setSuccess(true);
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    if (response?.response) {
      setSuccess(false);
      setMsg(response?.response?.data?.message);
    }
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleDescription = async (data, action) => {
    data.descriptionOrder = String(data.descriptionOrder);
    let obj = {};
    if (action == "delete") {
      let keyData = ["descriptionId"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      obj.isActive = false;
    } else if (action == "add") {
      let keyData = ["descriptionOrder", "descriptionUz", "descriptionEn"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      data.descriptionOrder = "1";
      obj.isActive = true;
    } else {
      obj = data;
      obj.isActive = true;
    }
    obj.productId = productParams.productId;
    obj.operation = action;
    const response = await updateProductDescriptionApi(obj);
    if (response?.success) {
      setMsg("Description Update Successfully");
      setSuccess(true);
      setIndexDimention("");
      setSeeDescription(false);
      setAddDescriptionShow(false);
      getProductDetails();
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };

  const handleCharacteristic = async (data, action) => {
    // data.characteristicOrder = String(data.characteristicOrder);
    let obj = {};
    if (action == "delete") {
      let keyData = ["productId", "characteristicId"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      obj.isActive = false;
    } else if (action == "add") {
      let keyData = ["keyEn", "keyUz", "valueEn", "valueUz"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      obj.characteristicOrder = "1";
      obj.isActive = true;
    } else {
      obj = data;
      obj.isActive = true;
      obj.characteristicOrder = "1";
    }
    obj.productId = productParams.productId;
    obj.operation = action;
    const response = await updateProductCharacteristicApi(obj);
    if (response?.success) {
      setMsg("Characteristic Update Successfully");
      setSuccess(true);
      setIndexCharacteristic("");
      setSeeCharacteristic(false);
      setAddCharacteristicShow(false);
      getProductDetails();
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };
  const handleWarranty = async (data, action) => {
    data.productId = productParams?.productId;
    let obj = {};
    if (action == "delete") {
      let keyData = ["productId", "productWarrantyId"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      obj.isActive = false;
    } else if (action == "add") {
      let keyData = ["descriptionEn", "descriptionUz", "price", "productId"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      obj.isActive = true;
      // obj.colorOrder = "1"
    } else {
      // obj.colorOrder = "1"
      obj = data;
      obj.isActive = true;
    }
    obj.operation = action;
    const response = await updateProductWarrantyApi(obj);
    if (response?.success) {
      setMsg("Warranty Update Successfully");
      setSuccess(true);
      setIndexWarranty("");
      setSeeWarranty(false);
      setAddWarrantyShow(false);
      getProductDetails();
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };
  const handleColor = async (data, action) => {
    let obj = {};
    data.productId = productParams?.productId;
    if (action == "delete") {
      let keyData = ["productId", "productColorId"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      obj.isActive = false;
    } else if (action == "add") {
      let keyData = ["colorOrder", "colorCode", "colorOrder", "inventory", "productId"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      obj.isActive = true;
      obj.colorOrder = "1";
    } else {
      obj = data;
      obj.isActive = true;
      obj.colorOrder = "1";
    }
    obj.operation = action;
    const response = await updateProductColorApi(obj);
    if (response?.success) {
      setMsg("Color Update Successfully");
      setSuccess(true);
      setIndexColor("");
      setSeeColor(false);
      setAddColorShow(false);
      getProductDetails();
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };
  const handleVideo = async (data, action) => {
    data.productId = productParams?.productId;
    let obj = {};
    if (action == "delete") {
      let keyData = ["productId", "productVideoId"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      obj.isActive = false;
    } else if (action == "add") {
      let keyData = ["video", "videoThumbnail", "productId"];
      obj = Object.fromEntries(Object.entries(data).filter(([key]) => keyData.includes(key)));
      obj.isActive = true;
      obj.videoOrder = String(1);
      // obj.colorOrder = "1"
    } else {
      // obj.colorOrder = "1"
      obj = data;
      obj.isActive = true;
      obj.videoOrder = String(1);
    }
    obj.operation = action;
    const response = await updateProductVideoApi(obj);
    if (response?.success) {
      setMsg("Video Update Successfully");
      setSuccess(true);
      setIndexVideo("");
      setSeeVideo(false);
      setAddVideoShow(false);
      getProductDetails();
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };
  // Add new Warranty
  const addVideo = () => {
    setSeeVideo(false);
    setAddVideoShow(true);
    setIndexVideo(productVideo?.length);
    setProductVideo([
      ...productVideo,
      { id: Date.now(), video: "", videoThumbnail: "", isActive: true },
    ]);
    // setProductVideo([...productVideo, { id: Date.now(), videoUrl: "", thumbnailUrl: "" }]);
  };
  // Remove a Video
  const removeVideo = id => {
    if (id != 1) setProductVideo(productVideo.filter(video => video.id !== id));
  };

  useEffect(() => {
    if (productParams?.productId) getProductDetails();
  }, [productParams?.productId]);

  useEffect(() => {
    getAllCategory();
  }, []);

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", paddingBottom: "10px" }}>
      <Card style={{ flex: 1, padding: "20px", minWidth: "100%" }}>
        {/* <DriveFileRenameOutlineRoundedIcon style={{position: 'absolute', right: '20px', top: '20px', fill: '#344767', cursor: 'pointer' }} /> */}
        <Typography variant='h6'>Product Basic Details</Typography>
        <form onSubmit={handleBasicDetail}>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Product Name in English'
              name='nameEn'
              variant='outlined'
              margin='normal'
              value={basicDetail?.nameEn}
              onChange={handleChangeBasicDetail}
            />
            <TextField
              required
              type='text'
              fullWidth
              label='Product Name in Ukrain'
              name='nameUz'
              variant='outlined'
              margin='normal'
              value={basicDetail?.nameUz}
              onChange={handleChangeBasicDetail}
            />
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Product Slug'
              name='slug'
              variant='outlined'
              margin='normal'
              value={basicDetail?.slug}
              style={{ width: "100%" }}
              onChange={handleChangeBasicDetail}
            />
            <TextField
              required
              type='text'
              fullWidth
              label='Product Code'
              name='productCode'
              variant='outlined'
              margin='normal'
              style={{ width: "67.5%" }}
              value={basicDetail?.productCode}
              onChange={handleChangeBasicDetail}
            />
            {/* <Typography component='legend'>Controlled</Typography>
            <Rating
              name='simple-controlled'
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            /> */}
            <TextField
              required
              type='number'
              select
              inputProps={{ min: 1, max: 5 }}
              fullWidth
              label='Product Rating'
              name='rating'
              variant='outlined'
              margin='normal'
              style={{ width: "30%" }}
              value={basicDetail.rating}
              onChange={handleChangeBasicDetail}
              className='rating-box'
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={1.1}>1.1</MenuItem>
              <MenuItem value={1.2}>1.2</MenuItem>
              <MenuItem value={1.3}>1.3</MenuItem>
              <MenuItem value={1.4}>1.4</MenuItem>
              <MenuItem value={1.5}>1.5</MenuItem>
              <MenuItem value={1.6}>1.6</MenuItem>
              <MenuItem value={1.7}>1.7</MenuItem>
              <MenuItem value={1.8}>1.8</MenuItem>
              <MenuItem value={1.9}>1.9</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={2.1}>2.1</MenuItem>
              <MenuItem value={2.2}>2.2</MenuItem>
              <MenuItem value={2.3}>2.3</MenuItem>
              <MenuItem value={2.4}>2.4</MenuItem>
              <MenuItem value={2.5}>2.5</MenuItem>
              <MenuItem value={2.6}>2.6</MenuItem>
              <MenuItem value={2.7}>2.7</MenuItem>
              <MenuItem value={2.8}>2.8</MenuItem>
              <MenuItem value={2.9}>2.9</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={3.1}>3.1</MenuItem>
              <MenuItem value={3.2}>3.2</MenuItem>
              <MenuItem value={3.3}>3.3</MenuItem>
              <MenuItem value={3.4}>3.4</MenuItem>
              <MenuItem value={3.5}>3.5</MenuItem>
              <MenuItem value={3.6}>3.6</MenuItem>
              <MenuItem value={3.7}>3.7</MenuItem>
              <MenuItem value={3.8}>3.8</MenuItem>
              <MenuItem value={3.9}>3.9</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={4.1}>4.1</MenuItem>
              <MenuItem value={4.2}>4.2</MenuItem>
              <MenuItem value={4.3}>4.3</MenuItem>
              <MenuItem value={4.4}>4.4</MenuItem>
              <MenuItem value={4.5}>4.5</MenuItem>
              <MenuItem value={4.6}>4.6</MenuItem>
              <MenuItem value={4.7}>4.7</MenuItem>
              <MenuItem value={4.8}>4.8</MenuItem>
              <MenuItem value={4.9}>4.9</MenuItem>
              <MenuItem value={5}>5</MenuItem>
            </TextField>
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='number'
              inputProps={{ min: 1 }}
              fullWidth
              label='Price'
              name='price'
              variant='outlined'
              margin='normal'
              style={{ width: "50%" }}
              value={basicDetail?.price}
              onChange={handleChangeBasicDetail}
            />
            <TextField
              required
              type='number'
              fullWidth
              inputProps={{ min: 1 }}
              label='Product Discount Price'
              name='discountPrice'
              variant='outlined'
              margin='normal'
              style={{ width: "47.5%" }}
              value={basicDetail?.discountPrice}
              onChange={handleChangeBasicDetail}
            />
            <CategoryClip
              categories={categories}
              selectedCategories={selectedCategory}
              setSelectedCategoryClone={setSelectedCategoryClone}
              setSelectedCategories={setSelectedCategory}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
            <button
              type='submit'
              style={{
                border: "1px solid #344767",
                background: "none",
                borderRadius: "4px",
                padding: "10px 10px",
                cursor: "pointer",
                // marginLeft: "auto",
                color: "#344767",
                fontSize: "12px",
                fontWeight: "500",
              }}
            >
              Update Basic Details
            </button>
          </div>
        </form>
      </Card>

      <Card style={{ flex: 1, padding: "20px", minWidth: "50%" }}>
        <Typography
          variant='h6'
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          Product Description
          {!addDescriptionShow && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                fontWeight: "500",
                cursor: "pointer",
              }}
              onClick={addDescription}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          )}
        </Typography>
        {/* <TextField /> */}
        {productDescription?.map(
          (description, index) =>
            description?.isActive && (
              <div
                key={description.id}
                style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}
              >
                <TextField
                  required
                  type='text'
                  fullWidth
                  label='Description in English'
                  name='descriptionEn'
                  variant='outlined'
                  margin='normal'
                  multiline
                  maxRows={4}
                  value={description.descriptionEn}
                  onChange={e => handleChangeDescription(index, e)}
                />
                <TextField
                  required
                  type='text'
                  fullWidth
                  label='Description in Ukrain'
                  name='descriptionUz'
                  variant='outlined'
                  margin='normal'
                  multiline
                  maxRows={4}
                  value={description.descriptionUz}
                  onChange={e => handleChangeDescription(index, e)}
                />
                <TextField
                  required
                  type='number'
                  inputProps={{ min: 1 }}
                  fullWidth
                  label='Order'
                  name='descriptionOrder'
                  variant='outlined'
                  margin='normal'
                  value={description.descriptionOrder}
                  onChange={e => handleChangeDescription(index, e)}
                />
                {seeDescription && (
                  <div style={{ display: "flex", paddingTop: "8px" }}>
                    {indexDimention == index && (
                      <TooltipShow
                        onSubmit={handleDescription}
                        data={description}
                        operation='edit'
                        icon={<UpgradeRoundedIcon />}
                        title={"Update"}
                      />
                    )}
                    {indexDimention == index && (
                      <TooltipShow
                        onSubmit={handleDescription}
                        data={description}
                        operation='delete'
                        icon={<DeleteIcon style={{ fill: "#f35252" }} />}
                        title={"Delete"}
                      />
                    )}
                  </div>
                )}
                {addDescriptionShow && (
                  <div style={{ display: "flex", paddingTop: "8px" }}>
                    {indexDimention == index && (
                      <TooltipShow
                        onSubmit={handleDescription}
                        data={description}
                        operation='add'
                        icon={<AddRoundedIcon />}
                        title={"Add"}
                      />
                    )}
                    {indexDimention == index && (
                      <Tooltip
                        title={"Close"}
                        onClick={() => {
                          removeDescription(description.id);
                          setAddDescriptionShow(false);
                        }}
                      >
                        <IconButton style={{ fontSize: "20px" }}>
                          <CloseRoundedIcon style={{ fill: "#f35252" }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                )}
              </div>
            )
        )}
      </Card>
      <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
        <Typography
          variant='h6'
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          Product Characteristic
          {!addCharacteristicShow && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                fontWeight: "500",
                cursor: "pointer",
              }}
              onClick={addCharacteristic}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          )}
        </Typography>
        {productCharacteristic?.map(
          (characteristic, index) =>
            characteristic?.isActive && (
              <div
                key={characteristic.id}
                style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}
              >
                <div>
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Characteristic Key in English'
                    name='keyEn'
                    variant='outlined'
                    margin='normal'
                    multiline
                    maxRows={4}
                    value={characteristic.keyEn}
                    onChange={e => handleChangeCharacteristic(index, e)}
                  />
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Characteristic Key in Ukrain'
                    name='keyUz'
                    variant='outlined'
                    margin='normal'
                    multiline
                    maxRows={4}
                    value={characteristic.keyUz}
                    onChange={e => handleChangeCharacteristic(index, e)}
                  />
                </div>
                <div>
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Characteristic Value in English'
                    name='valueEn'
                    variant='outlined'
                    margin='normal'
                    multiline
                    maxRows={4}
                    value={characteristic.valueEn}
                    onChange={e => handleChangeCharacteristic(index, e)}
                  />
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Characteristic Value in Ukrain'
                    name='valueUz'
                    variant='outlined'
                    margin='normal'
                    multiline
                    maxRows={4}
                    value={characteristic.valueUz}
                    onChange={e => handleChangeCharacteristic(index, e)}
                  />
                </div>
                {seeCharacteristic && (
                  <div style={{ display: "flex", paddingTop: "8px" }}>
                    {indexCharacteristic == index && (
                      <Tooltip
                        title={"Update"}
                        onClick={() => handleCharacteristic(characteristic, "edit")}
                      >
                        <IconButton style={{ fontSize: "20px" }}>
                          <UpgradeRoundedIcon />
                        </IconButton>
                      </Tooltip>
                      // <TooltipShow
                      //   onSubmit={handleCharacteristic}
                      //   data={characteristic}
                      //   operation='edit'
                      //   icon={<UpgradeRoundedIcon />}
                      //   title={"Update"}
                      // />
                    )}
                    {indexCharacteristic == index && (
                      <Tooltip
                        title={"Delete"}
                        onClick={() => handleCharacteristic(characteristic, "delete")}
                      >
                        <IconButton style={{ fontSize: "20px" }}>
                          <DeleteIcon style={{ fill: "#f35252" }} />
                        </IconButton>
                      </Tooltip>
                      // <TooltipShow
                      //   onSubmit={handleCharacteristic}
                      //   data={characteristic}
                      //   operation='delete'
                      //   icon={<DeleteIcon style={{ fill: "#f35252" }} />}
                      //   title={"Delete"}
                      // />
                    )}
                  </div>
                )}
                {addCharacteristicShow && (
                  <div style={{ display: "flex", paddingTop: "8px" }}>
                    {indexCharacteristic == index && (
                      <TooltipShow
                        onSubmit={handleCharacteristic}
                        data={characteristic}
                        operation='add'
                        icon={<AddRoundedIcon />}
                        title={"Add"}
                      />
                    )}
                    {indexCharacteristic == index && (
                      <Tooltip
                        title={"Close"}
                        onClick={() => {
                          removeCharacteristic(characteristic.id);
                          setAddCharacteristicShow(false);
                        }}
                      >
                        <IconButton style={{ fontSize: "20px" }}>
                          <CloseRoundedIcon style={{ fill: "#f35252" }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                )}
              </div>
            )
        )}
      </Card>
      <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
        <Typography
          variant='h6'
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          Product colors
          {!addColorShow && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                fontWeight: "500",
                cursor: "pointer",
              }}
              onClick={addColor}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          )}
        </Typography>
        {productColors?.map(
          (color, index) =>
            color?.isActive && (
              <div
                key={color.id}
                style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}
              >
                <TextField
                  required
                  type='color'
                  fullWidth
                  label='Color'
                  name='colorCode'
                  variant='outlined'
                  margin='normal'
                  value={color.colorCode}
                  onChange={e => handleChangeColor(index, e)}
                />
                <TextField
                  required
                  type='number'
                  inputProps={{ min: 0 }}
                  fullWidth
                  label='Inventory'
                  name='inventory'
                  variant='outlined'
                  margin='normal'
                  value={color.inventory}
                  onChange={e => handleChangeColor(index, e)}
                />
                {seeColor && (
                  <div style={{ display: "flex", paddingTop: "8px" }}>
                    {indexColor == index && (
                      <TooltipShow
                        onSubmit={handleColor}
                        data={color}
                        operation='edit'
                        icon={<UpgradeRoundedIcon />}
                        title={"Update"}
                      />
                    )}
                    {indexColor == index && (
                      <TooltipShow
                        onSubmit={handleColor}
                        data={color}
                        operation='delete'
                        icon={<DeleteIcon style={{ fill: "#f35252" }} />}
                        title={"Delete"}
                      />
                    )}
                  </div>
                )}
                {addColorShow && (
                  <div style={{ display: "flex", paddingTop: "8px" }}>
                    {indexColor == index && (
                      <TooltipShow
                        onSubmit={handleColor}
                        data={color}
                        operation='add'
                        icon={<AddRoundedIcon />}
                        title={"Add"}
                      />
                    )}
                    {indexColor == index && (
                      <Tooltip
                        title={"Close"}
                        onClick={() => {
                          removeColor(color.id);
                          setAddColorShow(false);
                        }}
                      >
                        <IconButton style={{ fontSize: "20px" }}>
                          <CloseRoundedIcon style={{ fill: "#f35252" }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                )}
              </div>
            )
        )}
      </Card>

      <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
        <Typography variant='h6'>Product Dimensions</Typography>
        <form onSubmit={handleDimention}>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='number'
              fullWidth
              label='Weight(kg)'
              name='weight'
              variant='outlined'
              margin='normal'
              value={dimensions?.weight}
              onChange={handleChangeDimentions}
            />
            <TextField
              required
              type='text'
              fullWidth
              label='Width(cm)'
              name='width'
              variant='outlined'
              margin='normal'
              value={dimensions?.width}
              onChange={handleChangeDimentions}
            />
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Height(cm)'
              name='height'
              variant='outlined'
              margin='normal'
              value={dimensions?.height}
              onChange={handleChangeDimentions}
            />
            <TextField
              required
              type='text'
              fullWidth
              label='Length(cm)'
              name='length'
              variant='outlined'
              margin='normal'
              value={dimensions?.length}
              onChange={handleChangeDimentions}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
            <button
              type='submit'
              style={{
                border: "1px solid #344767",
                borderRadius: "4px",
                padding: "10px",
                color: "#344767",
                fontSize: "12px",
                fontWeight: "500",
                marginTop: "10px",
                fontWeight: "500",
                background: "none",
              }}
            >
              Update Dimention
            </button>
          </div>
        </form>
      </Card>
      <Card style={{ flex: 1, padding: "20px", minWidth: "100%" }}>
        <Typography
          variant='h6'
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          Product Warranty
          {!addWarrantyShow && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                fontWeight: "500",
                cursor: "pointer",
              }}
              onClick={addWarranty}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          )}
        </Typography>
        {productWarranty?.length > 0 &&
          productWarranty.map(
            (warranty, index) =>
              warranty?.status && (
                <div
                  key={warranty.id}
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "0px",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Warranty Description in English'
                    name='descriptionEn'
                    variant='outlined'
                    margin='normal'
                    multiline
                    maxRows={4}
                    value={warranty.descriptionEn}
                    onChange={e => handleChangeWarranty(index, e)}
                  />
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Warranty Description in Ukrain'
                    name='descriptionUz'
                    variant='outlined'
                    margin='normal'
                    multiline
                    maxRows={4}
                    value={warranty.descriptionUz}
                    onChange={e => handleChangeWarranty(index, e)}
                  />
                  <TextField
                    required
                    type='number'
                    fullWidth
                    inputProps={{ min: 0 }}
                    label='Price'
                    name='price'
                    variant='outlined'
                    margin='normal'
                    value={warranty.price}
                    onChange={e => handleChangeWarranty(index, e)}
                  />
                  {seeWarranty && (
                    <div style={{ display: "flex", paddingTop: "8px" }}>
                      {indexWarranty == index && (
                        <TooltipShow
                          onSubmit={handleWarranty}
                          data={warranty}
                          operation='edit'
                          icon={<UpgradeRoundedIcon />}
                          title={"Update"}
                        />
                      )}
                      {indexWarranty == index && (
                        <TooltipShow
                          onSubmit={handleWarranty}
                          data={warranty}
                          operation='delete'
                          icon={<DeleteIcon style={{ fill: "#f35252" }} />}
                          title={"Delete"}
                        />
                      )}
                    </div>
                  )}
                  {addWarrantyShow && (
                    <div style={{ display: "flex", paddingTop: "8px" }}>
                      {indexWarranty == index && (
                        <TooltipShow
                          onSubmit={handleWarranty}
                          data={warranty}
                          operation='add'
                          icon={<AddRoundedIcon />}
                          title={"Add"}
                        />
                      )}
                      {indexWarranty == index && (
                        <Tooltip
                          title={"Close"}
                          onClick={() => {
                            removeWarranty(warranty.id);
                            setAddWarrantyShow(false);
                          }}
                        >
                          <IconButton style={{ fontSize: "20px" }}>
                            <CloseRoundedIcon style={{ fill: "#f35252" }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  )}
                </div>
              )
          )}
        {/* <span
          style={{
            border: "1px solid #344767",
            borderRadius: "4px",
            padding: "5px 10px",
            marginLeft: "auto",
            color: "#344767",
            fontSize: "12px",
            fontWeight: "500",
            marginTop: "10px",
          }}
        >
          Update Warranty
        </span> */}
      </Card>

      <Card style={{ flex: 1, padding: "20px", minWidth: "100%" }}>
        <Typography
          variant='h6'
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          Product Video
          {!addVideoShow && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                cursor: "pointer",
              }}
              onClick={addVideo}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          )}
        </Typography>
        {productVideo?.length > 0 &&
          productVideo.map(
            (video, index) =>
              video?.isActive && (
                <div
                  key={video.id}
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "0px",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Video link'
                    name='video'
                    variant='outlined'
                    margin='normal'
                    value={video.video}
                    onChange={e => handleChangeVideo(index, e)}
                  />
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Video thumbnail link'
                    name='videoThumbnail'
                    variant='outlined'
                    margin='normal'
                    value={video.videoThumbnail}
                    onChange={e => handleChangeVideo(index, e)}
                  />
                  {seeVideo && (
                    <div style={{ display: "flex", paddingTop: "8px" }}>
                      {indexVideo == index && (
                        <TooltipShow
                          onSubmit={handleVideo}
                          data={video}
                          operation='edit'
                          icon={<UpgradeRoundedIcon />}
                          title={"Update"}
                        />
                      )}
                      {indexVideo == index && (
                        <TooltipShow
                          onSubmit={handleVideo}
                          data={video}
                          operation='delete'
                          icon={<DeleteIcon style={{ fill: "#f35252" }} />}
                          title={"Delete"}
                        />
                      )}
                    </div>
                  )}
                  {addVideoShow && (
                    <div style={{ display: "flex", paddingTop: "8px" }}>
                      {indexVideo == index && (
                        <TooltipShow
                          onSubmit={handleVideo}
                          data={video}
                          operation='add'
                          icon={<AddRoundedIcon />}
                          title={"Add"}
                        />
                      )}
                      {indexVideo == index && (
                        <Tooltip
                          title={"Close"}
                          onClick={() => {
                            removeVideo(video.id);
                            setAddVideoShow(false);
                          }}
                        >
                          <IconButton style={{ fontSize: "20px" }}>
                            <CloseRoundedIcon style={{ fill: "#f35252" }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  )}
                </div>
              )
          )}
      </Card>

      {/* <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            paddingTop: "20px",
            width: "100%",
          }}
        >
          <Button color='warning' variant='contained'>
            Cancel
          </Button>
          <Button variant='contained' color='success' type='submit'>
            Submit
          </Button>
        </div> */}
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
};

export default ProductEditForm;

// </form>
